import React from 'react';

import { medianClockIn } from 'assets/images';

import { convertTimeToAMPMWithDots } from 'utils/time';

type ClockInTimeProps = {
  medianClockInTime: string | null;
};

export function ClockInTime({ medianClockInTime }: ClockInTimeProps) {
  return (
    <div>
      <div className="median-office-time__clock-in d-flex gap-x-4 p-4">
        <img src={medianClockIn} alt="Office clock in time" />
        <div>
          <div className="font-size-16 d-flex gap-x-4 align-items-center">
            <span>WFO</span>
            <span className="median-office-time__clock-in__time font-weight-semi-bold">
              {(medianClockInTime && convertTimeToAMPMWithDots(medianClockInTime)) || '-'}
            </span>
          </div>
          <div className="median-office-time__clock-in__text font-size-12 color-grey-60">median clock-in time</div>
        </div>
      </div>
    </div>
  );
}

export default ClockInTime;
